import CountrySelect from "../../components/inputs/country_select.js";
import { api } from "../../app/api.js";
import { store } from "../../app/store.js";
import {display_errors} from "../../helpers/forms.js";

export default {
    template: `
        <div class="column marg-top">
            <div class="container">
                <h1>My Details</h1>
        
                <form id="details-form" class="form">
                    <div class="input">
                        <label for="Email">Email Address</label>
                        <input type="text" id="Email" name="email" disabled/>
                    </div>
        
                    <div class="input">
                        <label for="FirstName">First Name</label>
                        <input type="text" id="FirstName" name="first_name" required/>
                    </div>
        
                    <div class="input">
                        <label for="LastName">Last Name</label>
                        <input type="text" id="LastName" name="last_name" required/>
                    </div>
                    
                    <div id="CountrySelect" class="input_wrapper"></div>
        
                    <div class="input">
                        <input type="checkbox" id="MarketingConsent" name="marketing_consent"/>
                        <label for="MarketingConsent">I would like to receive marketing and promotional emails</label>
                    </div>
        
                    <button id="DetailsSave" type="submit">Save</button>
                    <div id="DetailsSaveErrors" class="errors hidden"></div>
                </form>
            </div>
        </div>
     `,

    $form: null,
    $error_msg: null,
    $submit: null,


    submit (event) {
        event.preventDefault();

        this.$submit.disabled = true;
        this.$submit.textContent = 'Saving...';
        this.$error_msg.classList.add('hidden');
        this.$error_msg.textContent = '';

        api.post({
            url: '/account/update',
            data: {
                first_name: this.$form.first_name.value,
                last_name: this.$form.last_name.value,
                country_code: this.$form.country.value,
                marketing_consent: this.$form.marketing_consent.checked === 'on',
            },
            success: (response) => {
                console.log('Details saved successfully.');

                this.$submit.textContent = 'Saved';
                this.$submit.classList.add('green');
                this.$submit.disabled = false;

                api.clear_cache('/account/details');
            },
            error: (response) => {
                display_errors(this.$error_msg, response, this.$form);

                this.$submit.textContent = 'Save';
                this.$submit.disabled = false;
            }
        });
    },
    _boundSubmit: null,

    async onMount() {
        const auth = store.get('auth');

        if (!auth.logged_in) {
            window.history.pushState({}, "", "/");
            window.dispatchEvent(new PopStateEvent('popstate'));
        }

        this.$form = document.getElementById('details-form');
        this.$error_msg = document.getElementById('DetailsSaveErrors');
        this.$submit = document.getElementById('DetailsSave');

        const $country_container = document.getElementById('CountrySelect');
        const $countrySelect = CountrySelect({
            id: 'Country',
            value: '',
            onChange: (selected) => {
                console.log('Selected country:', selected);
            }
        });

        $country_container.appendChild($countrySelect.render());

        api.get({
            url: '/account/details',
            success: (response) => {
                this.$form.email.value = response.email ?? '';
                this.$form.first_name.value = response.first_name ?? '';
                this.$form.last_name.value = response.last_name ?? '';
                this.$form.country.value = response.country ?? '';
            },
            error: (response) => {
                display_errors(this.$error_msg, response, this.$form);
            }
        });

        this._boundSubmit = this.submit.bind(this);
        this.$form.addEventListener('submit', this._boundSubmit);
    },

    onUnmount() {
        if (this._boundSubmit) this.$form.removeEventListener('submit', this._boundSubmit);
    },
};
